import React, { useEffect, useState } from "react";
import { promotionsData } from ".";
import { useParams } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

import { useSelector } from "react-redux";
import Header from "../../../../containers/Header";

import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Footer from "../../../../containers/Footer";
import ModalWrapper from "../../../../containers/ModalWrapper";
import { APP_CONST } from "../../../../config/const";

const DynamicPromotion = () => {
  const { id } = useParams();

  const { isAuth } = useSelector((state) => state.auth);

  const [dataToRender, setDataToRender] = useState();

  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState(APP_CONST.AUTH_MODAL.LOGIN);
  const handleModalShow = (modalName) => {
    setShowAuthModals(true);

    setDefaultModal(modalName);
  };

  const redirection = (href) => {
    if (isAuth) {
      window.location.href = href;
    } else {
      handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
    }
  };
  useEffect(() => {
    const data = promotionsData?.filter((item) => {
      return item?.keyUrl === id;
    });
    setDataToRender(data);
  }, []);

  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main">
        <div className="promotions-card-details">
          {Array?.isArray(dataToRender) &&
            dataToRender.map((item) => {
              return (
                <>
                  <div className="top-banner">
                    <img src={item?.image} alt="bonus banner" />
                  </div>
                  <div className="blur-overlay"></div>
                  <div className="ContainerCss">
                    <div className="promotions-detail">
                      <div className="left-content d-none d-lg-block">
                        <img src={item?.image} />
                        <a
                          href={"#"}
                          onClick={() => redirection(item?.href)}
                          className="btn"
                        >
                          Get the Bonus
                        </a>
                      </div>

                      <div className="right-content">
                        <div className="top-head">
                          <a href={item?.href} className="btn">
                            Get the Bonus
                          </a>
                          <h2>{item?.title}</h2>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-8">
                            <h3 className="d-none d-lg-block">
                              {item?.subTitle}
                            </h3>
                            <p>{item?.content}</p>
                          </div>
                          <div className="col-md-4 promoImage d-none d-md-block">
                            <img src={item?.image_2} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            handleClose={setShowAuthModals}
          />
        )}
      </main>

      {isAuth ? <Footer /> : <BeforeLoginFooter />}
    </>
  );
};

export default DynamicPromotion;
